import { useState } from 'react';
import { useLocation,useNavigate } from "react-router-dom";
import { validationMessage } from '../../../configure/validationConfig';
import { handleConfirmSignUp } from '../../../api/Auth';
import SnackbarComponent from '../../../components/CustomBarComponent';
import CustomLabelInput from '../../../components/Custom/CustomLabelInput';
import CustomAPICalls from '../../../api/public/CustomAPICalls';
import Processing from '../../../components/Processing';

// material-ui
import {
    Button,
    Grid,
    Stack,
} from "@mui/material";


//third Party
import * as Yup from "yup";
import { Formik } from "formik";



const VerifyConfirmationCode = () => {
    const location = useLocation();
    const {email = '', token = ''} = location?.state || {};
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const [snackbarState, setSnackbarState] = useState({
        open: false,
        message: "",
      }); 

    return (
        <>
        {Processing(loading)}
        <SnackbarComponent
            snackbarState={snackbarState}
            setSnackbarState={setSnackbarState}
        />
            <Formik
                initialValues={{
                    emailCode: "", 
                }}
                validationSchema={Yup.object().shape({
                emailCode: Yup.string()
                    .required(validationMessage.ENTER_INVITE_CODE),
                })}

                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                    setStatus({ success: false });
                    setSubmitting(true);
                    setLoading(true);
                    
                    try{
                        const obj = {
                            email: email,
                            token: token,
                        };

                        const confirmSignUp = await handleConfirmSignUp(email, values.emailCode);
                        
                        // console.log(confirmSignUp);
                        if(confirmSignUp === "SUCCESS"){
                            await CustomAPICalls(obj, "/token/deleteToken");
                            navigate("/register_success");
                        }else{
                            setSnackbarState({ open: true, message: "Error: can't confirm sign up "});
                        }
                    }catch(error){
                        setSnackbarState({ open: true, message: "Error: " + error.message || "Error with confirm sign up "}); 
                    }
                    setLoading(false);
                    setSubmitting(false);
                   
                }}
            >
                {({
                handleSubmit,
                isSubmitting,
                }) => (
                    <form noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Stack spacing={1}>
                                <CustomLabelInput
                                    label="Activation code"
                                    name="emailCode"
                                    disabled={isSubmitting}
                                    placeholder="Enter 6-digit code"
                                />
                            </Stack>
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                disableElevation
                                disabled={isSubmitting}
                                fullWidth
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Verify
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                )}
            </Formik>
        </>
    )
}

export default VerifyConfirmationCode;